/* unplugin-vue-components disabled */import script from "./googleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./googleDetail.vue?vue&type=script&setup=true&lang=ts"

import "./googleDetail.vue?vue&type=style&index=0&id=60a01f9a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a01f9a"]])

export default __exports__